import { parseStoreData } from "./helpers";

export const actionType = {
  INIT_STORE: "STORE.INIT",
  UPDATE_STORE: "STORE.UPDATE",
  CLEAR_STORE: "STORE.CLEAR",
  SET_CREDIT: "STORE.SET_CREDIT",
};

const actions = {
  initStore: (store) => {
    return {
      type: actionType.INIT_STORE,
      data: store,
    };
  },
  setCredit: (credit) => {
    return {
      type: actionType.SET_CREDIT,
      data: credit,
    };
  },
  updateStore: (newSetting) => (dispatch) => {
    dispatch({
      type: actionType.UPDATE_STORE,
      data: parseStoreData(newSetting),
    });
  },
  clearStore: () => {
    return {
      type: actionType.CLEAR_STORE,
    };
  },
};

export default actions;
